import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Activity } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setAuthState } = useApp();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        if (data.session_token) localStorage.setItem("session_token", data.session_token);
        setUser(data);
        setAuthState("authed");
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Authentication failed. Please try again.");
        setTimeout(() => navigate("/"), 1800);
      }
    })();
  }, [navigate, setUser, setAuthState]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#080b11] text-center px-6">
      <Activity className="w-8 h-8 text-[#00e5ff] animate-pulse mb-4" />
      <p className="font-mono text-sm text-[#94a3b8]" data-testid="auth-callback-status">
        {error || "Establishing secure session…"}
      </p>
    </div>
  );
}
